import * as prohibitedActions from "./../actions/prohibitedItems";
import { getListProhibitedItems, updateLastCheckedKeywordUser } from "./../utils/prohibitedItems";
import hanldeException from './../services/handleException';
import { put, takeLatest, join } from 'redux-saga/effects';
import { convertDateFromUTC, convertDateToUTC } from './../services/dst';
import moment from 'moment-timezone';

function* getListProhibitedHandle(data) {
    try {
        const json = yield getListProhibitedItems(data.payload)
        if (json.data.code === 10001) {
            if (json.data.data) {
                yield put({ type: prohibitedActions.GET_LIST_PROHIBITED_ITEMS_SUCCESS, payload: json.data.data.ProhibitedKeyWords})
                yield put({ type: prohibitedActions.CHECK_COOKIES_DISPLAY_CONTENT_WARNING})
                if (json.data.data.LastestUpdateDT) {
                    yield put({ type: prohibitedActions.CHECK_COOKIES_LAST_UPDATE_ITEM_PROHIBITED, payload: json.data.data})
                }
                
            }
           
        }
    } catch (error) {
        hanldeException(error)
        yield put({ type: prohibitedActions.GET_LIST_PROHIBITED_ITEMS_FAILS, error })
    }
}

function* updateLastCheckedKeywordHandle(data) {
    try {
        const json = yield updateLastCheckedKeywordUser(data.payload)
        if (json.data.code === 10001) {
        }
    } catch (error) {
        hanldeException(error)
    }
}

export function* getListProhibitedSaga() {
    yield takeLatest(prohibitedActions.GET_LIST_PROHIBITED_ITEMS, getListProhibitedHandle)
}

export function* updateLastCheckedKeywordSaga() {
    yield takeLatest(prohibitedActions.ON_CHANGE_DISPLAY_NEW_UPDATE_PROHIBITED, updateLastCheckedKeywordHandle)
}


// WEBPACK FOOTER //
// ./src/sagas/prohibitedItemsSaga.js